module.exports = __webpack_public_path__ + "static/img/200079.9f4e7ad1.png";